import { useForm } from 'react-hook-form';

export interface EliminationsFormValues {
  name: string;
  category: string;
}

export const useEliminationsForm = () => {
  const { control, formState, handleSubmit, reset, setValue } = useForm<EliminationsFormValues>({
    defaultValues: {
      name: '',
      category: ''
    },
    mode: 'onChange'
  });

  return {
    control,
    formState,
    handleSubmit,
    reset,
    setValue
  };
};
